import { Navigate } from 'react-router-dom';
import usePermissoes from '../hooks/usePermissoes';

const PrivateRoute = ({ children, requiredPermission }) => {
  const isAuthenticated = localStorage.getItem('token');
  const { hasPermission } = usePermissoes();

  return isAuthenticated && hasPermission(requiredPermission) ? (
    children
  ) : (
    <Navigate to={isAuthenticated ? "/acesso-negado" : "/login"} />
  );
};

export default PrivateRoute;
